module.exports = __webpack_public_path__ + "img/FR11306.de595f02.svg";